import * as _ from 'lodash';

export class ArrayHelper {
  static lastOrUndef<T>(array: T[]) {
    if (!array || array.length === 0) {
      return;
    }

    return array[array.length - 1];
  }

  public static removeItem<T>(array: T[], item: T) {
    const index = array.indexOf(item);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  static groupBy<T>(array: T[], field: keyof T) {
    return _.groupBy(array, field);
  }

  /**
   * Generic method which returns a Map
   * of items from the given array
   * grouped by distinct keys
   * ex.
   * console.log(groupBy(['one', 'two', 'three'], 'length'));
   * => {3: ["one", "two"], 5: ["three"]}
   * @param array
   * @param key
   */
  public static groupByMap<T, K extends keyof T>(array: T[], key: K): Map<T[K], T[]> {
    const map = new Map<T[K], T[]>();
    array.forEach(item => {
      const itemKey = item[key];
      if (!map.has(itemKey)) {
        map.set(
          itemKey,
          array.filter(i => i[key] === item[key])
        );
      }
    });
    return map;
  }

  /**
   * Generic method which returns sum
   * of values from the given property
   * Ideally should be used with numeric values
   * @param array
   * @param property
   */
  public static sumOf<T, K extends keyof T>(array: T[], property: K): T[K] {
    return array
      .map(a => a[property])
      .reduce(function (a, b) {
        return (a as any) + b;
      });
  }
}
